import CommunicationService, { IResponse } from '../../../Utils/CommunicationService';
import { ISubscription } from './SubscriptionPlan.type';

export const getSetupIntentKeyUnregistered = async () => {
  const result = await CommunicationService.getInstance().secureCall<any>({
    type: 'POST',
    path: '/api/stripe/register'
  });
  if (result.body) {
    return result.body;
  }
  return false;
};

export const getSetupIntentKeyRegistered = async () => {
  const result = await CommunicationService.getInstance().secureCall<any>({
    type: 'GET',
    path: '/api/stripe/setupintent'
  });
  if (result.body) {
    return result.body;
  }
  return false;
};

export const proceedToPayment = async (unlock?: boolean) => {
  const selectedPlan = localStorage.getItem('selected_plan');
  const coupon = localStorage.getItem('v+coupon');
  const body = {
    priceId: selectedPlan || undefined,
  } as {priceId?: string, couponCode?: string, unlock?: boolean};
  if (coupon) {
    body.couponCode = coupon;
  }
  if (unlock) {
    body.unlock = true;
  }
  const result = await CommunicationService.getInstance().secureCall<{
    valid: boolean;
    error?: string;
  }>({
    type: 'POST',
    path: '/api/stripe/subscription/create',
    body
  });
  if (result.body) {
    if (result.body.valid) {
      localStorage.removeItem('selected_plan');
      localStorage.removeItem('v+coupon');
    }
    return result.body;
  }
  return {
    valid: false,
    error: 'communication_error'
  };
};

export const lookupCouponCode = async (couponCode: string) => {
  const result = await CommunicationService.getInstance().secureCall<any>({
    type: 'GET',
    path: `/api/stripe/coupon?code=${couponCode}`
  });
  if (result.body) {
    return result.body.coupon;
  }
  return false;
};

export const getSubscriptions = async () => {
  const result = await CommunicationService.getInstance().secureCall<any>({
    type: 'GET',
    path: '/api/stripe/list'
  });
  if (result.body) {
    return result.body.list.map(
      (prod: ISubscription) => ({
        ...prod,
        metadata: {
          ...prod.metadata,
          features: JSON.parse(prod.metadata.features)
        }
      })
    );
  }
  return false;
};

export const getMyDoInfo = async (doId: string) => {
  
  const result = await CommunicationService.getInstance().secureCall<any>({
    type: 'GET',
    path: `/api/dentaloffice/${doId}`
  });

  if (result.body) {
    return result.body.planType;
  }
  throw new Error('Failed to get DO info for ID: ' + doId);
};

export const setupFreemium = async () => {
  const result = await CommunicationService.getInstance().secureCall<any>({
    type: 'POST',
    path: '/api/stripe/subscription/freemium'
  });

  if (result.statusCode === 201) {
    return true;
  }
  return false;
};